import { render, staticRenderFns } from "./PaymentSection.vue?vue&type=template&id=2cccf84a&scoped=true&"
import script from "./PaymentSection.vue?vue&type=script&lang=js&"
export * from "./PaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSection.vue?vue&type=style&index=0&id=2cccf84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cccf84a",
  null
  
)

export default component.exports